import { render } from "./CMagazineType.vue?vue&type=template&id=2c4da229"
import script from "./CMagazineType.vue?vue&type=script&lang=js"
export * from "./CMagazineType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__